// ============================================================
// MULTI-TENANT: src/services/tenantService.js
// Funções de acesso a dados do tenant.
// Nova arquitetura: tenant detectado pelo LOGIN, não por subdomínio.
// ============================================================

import supabase from './supabaseClient';

/**
 * Verifica se o hostname atual é o subdomínio admin.
 * Usado para exibir o painel SuperAdmin.
 *
 * @returns {boolean}
 */
export function isAdminSubdomain() {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isLocalhost) {
    return (process.env.REACT_APP_TENANT_DEV || '') === 'admin';
  }

  const parts = hostname.split('.');
  return parts[0] === 'admin';
}

/**
 * Busca os dados de um tenant pelo ID.
 * Usado após o login para carregar os dados da empresa do usuário.
 *
 * @param {string} id - UUID do tenant
 * @returns {Promise<Object|null>}
 */
export async function getTenantById(id) {
  if (!id) return null;

  const { data, error } = await supabase
    .from('tenants')
    .select('*')
    .eq('id', id)
    .eq('ativo', true)
    .single();

  if (error) {
    if (error.code !== 'PGRST116') {
      console.error('[tenantService] Erro ao buscar tenant por ID:', error.message);
    }
    return null;
  }

  return data;
}

/**
 * Busca os dados do tenant no Supabase pelo subdomínio.
 * Mantido para uso pelo SuperAdmin e compatibilidade.
 *
 * @param {string} subdominio - Ex: "chamagas"
 * @returns {Promise<Object|null>}
 */
export async function getTenantBySubdominio(subdominio) {
  if (!subdominio) return null;

  const { data, error } = await supabase
    .from('tenants')
    .select('*')
    .eq('subdominio', subdominio)
    .single();

  if (error) {
    if (error.code !== 'PGRST116') {
      console.error('[tenantService] Erro ao buscar tenant por subdomínio:', error.message);
    }
    return null;
  }

  return data;
}
